import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter } from "lucide-react";
import Logo from "@/components/ui/Logo";

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 py-12">
          <div className="space-y-4">
            <Logo size="large" />
            <p className="text-gray-600 text-sm max-w-xs">
              Platforma më e madhe për blerjen dhe shitjen e produkteve të
              përdorura në Shqipëri.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://m.facebook.com/profile.php?id=61575655334321"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-green-500 transition-colors"
              >
                <Facebook size={20} />
              </a>
              <a
                href="#"
                className="text-gray-500 hover:text-green-500 transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a
                href="#"
                className="text-gray-500 hover:text-green-500 transition-colors"
              >
                <Twitter size={20} />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Për Ne</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/about"
                  className="text-gray-600 hover:text-green-500 transition-colors"
                >
                  Rreth Nesh
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-600 hover:text-green-500 transition-colors"
                >
                  Kontakt
                </Link>
              </li>
              <li>
                <Link
                  to="/cmime"
                  className="text-gray-600 hover:text-green-500 transition-colors font-medium"
                >
                  Çmimet
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Ndihma</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/help"
                  className="text-gray-600 hover:text-green-500 transition-colors"
                >
                  Qendra e Ndihmës
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-gray-600 hover:text-green-500 transition-colors"
                >
                  Kushtet e Përdorimit
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-gray-600 hover:text-green-500 transition-colors"
                >
                  Privatësia
                </Link>
              </li>
              <li>
                <Link
                  to="/safety"
                  className="text-gray-600 hover:text-green-500 transition-colors"
                >
                  Siguria
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-gray-100 text-center text-sm text-gray-500">
          <p>
            © {new Date().getFullYear()} Tregu. Të gjitha të drejtat të
            rezervuara.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
